import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { servicesData } from "../data/servicesData";
import { locationsData } from "../data/locationsData";

const Footer = () => {
  const reorderedServices = [
    servicesData[0],  // Keep first item in original position
    servicesData[1],  // Keep second item in original position
    servicesData.find(service => service.id === "event-services"),    // Event Management moves to 3rd
    servicesData.find(service => service.id === "temporary-fencing"), // Temporary Fencing moves to 4th
    servicesData.find(service => service.id === "certified-flaggers"), // Certified Flaggers moves to 5th
    servicesData[servicesData.length - 1]  // Keep last item in original position
  ];

  return (
    <>
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 justify-items-center">
            <div className="col-span-1 flex flex-col items-center md:items-start space-y-6">
              <Link to="/" className="block" onClick={() => window.scrollTo(0, 0)}>
                <img 
                  src="/lovable-uploads/aab48b83-0dca-4d12-be84-9b60e3f0b2be.png" 
                  alt="USA Traffic Control Logo" 
                  className="h-20 w-auto object-contain"
                />
              </Link>
              <div>
                <h3 className="text-xl font-bold mb-2 text-orange-500">Contact Us</h3>
                <ul className="space-y-2">
                  <li className="flex items-center gap-2">
                    <Mail size={16} className="text-orange-500" />
                    Hello@USATrafficControl.com
                  </li>
                  <li className="flex items-center gap-2">
                    <Phone size={16} className="text-orange-500" />
                    720-298-9505
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4 text-orange-500">Locations</h3>
              <ul className="space-y-2">
                {locationsData.map(location => (
                  <li key={location.id}>
                    <Link 
                      to={`/locations#${location.id}`} 
                      className="hover:text-orange-500"
                      onClick={() => {
                        const element = document.getElementById(location.id);
                        if (element) {
                          element.scrollIntoView({ behavior: "smooth" });
                        }
                      }}
                    >
                      {location.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4 text-orange-500">Services</h3>
              <ul className="space-y-2">
                {reorderedServices.map(service => (
                  <li key={service.id}>
                    <Link 
                      to={`/services#${service.id}`} 
                      className="hover:text-orange-500"
                      onClick={() => {
                        const element = document.getElementById(service.id);
                        if (element) {
                          element.scrollIntoView({ behavior: "smooth" });
                        }
                      }}
                    >
                      {service.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4 text-orange-500">Links</h3>
              <ul className="space-y-2">
                <li><a href="https://trafficplansonline.com" target="_blank" rel="noopener noreferrer" className="hover:text-orange-500">TrafficPlansOnline.com</a></li>
                <li><a href="https://manlysoaps.com" target="_blank" rel="noopener noreferrer" className="hover:text-orange-500">ManlySoaps.com</a></li>
                <li><a href="#" className="hover:text-orange-500">Company Blog</a></li>
                <li><a href="https://chrome.biz" target="_blank" rel="noopener noreferrer" className="hover:text-orange-500">Chrome.Biz</a></li>
                <li><Link to="/about" className="hover:text-orange-500">About Us</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      <div className="bg-black text-white py-3">
        <div className="container mx-auto px-4 text-center">
          <p>&copy; 2024 USA Traffic Control. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default Footer;
